export default [
  { title: 'Ø Wohndauer', key: 'durationOfResidence', postFix: 'J.' },
  { title: 'Ø Alter', key: 'residentsAge', postFix: 'J.' },
  { title: 'Anteil Familien', key: 'families' },
  { title: 'Anteil Singles', key: 'singles' },
];
